module.exports = __webpack_public_path__ + "img/9788970636191.a2fbce0b.jpg";